import {
    CognitoIdentityProviderClient,
    CognitoIdentityProviderClientConfig,
    SignUpCommand,
    SignUpCommandOutput,
} from '@aws-sdk/client-cognito-identity-provider'
import getConfig from 'next/config'

async function signUp(
    data: Record<string, string>
): Promise<SignUpCommandOutput> {
    const { COGNITO_CLIENT_ID: client_id, COGNITO_REGION: region } =
        getConfig().publicRuntimeConfig
    const { email, password, given_name, family_name, user_type, tenant_id } = data
    const config: CognitoIdentityProviderClientConfig = { region }
    const client = new CognitoIdentityProviderClient(config)

    const user_attributes = [
        { Name: 'given_name', Value: given_name },
        { Name: 'family_name', Value: family_name },
        { Name: 'custom:user_type', Value: user_type },
    ]
    if (user_type == 'CLIENT' && tenant_id) {
        user_attributes.push({ Name: 'custom:tenant_id', Value: tenant_id })
    }

    const command = new SignUpCommand({
        ClientId: client_id,
        Username: email,
        Password: password,
        UserAttributes: user_attributes
    })

    return await client.send(command)
}

export default signUp
